import { FileText } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const offerteManifest: ModuleDefinition = {
  id: 'offerte',
  name: 'Offertes',
  icon: <FileText size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/offerte',
  status: 'active',
  navItems: [
    { label: 'Offertes', path: '/offerte', icon: '📄' },
  ],
  component: () => import('./index.js'),
};

export default offerteManifest;
